<template>
    <h1 class="not-found text-center py-5 my-5">Страницата не съществува</h1>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>